import { round } from "../exports/helpers.js";
export default function toPercentage(value, totalValue, numDigits = 2) {
    return `${round((value / totalValue) * 100, numDigits)}%`;
}
//# sourceMappingURL=toPercentage.js.map